<mat-dialog-content>
  <section class="w3l-hero-headers-11 p-sticky-md">
      <div class="top-header"  >
          <div class="d-grid grid-columns-top-3" >
              <div class="search" >
                  <form action="search-results.html" method="get" style="position: absolute;left: 32%;width: 80%;">
                      <input id="search" name="search" type="text" [(ngModel)]="bnkCode"
                          placeholder="Code" style="width: 10%;">
                      <label>  </label>
                      <input id="search" name="search" type="text" [(ngModel)]="bnkName"
                         placeholder="Name" style="width: 30%;">

                  </form>
              </div>
          </div>
      </div>
  </section>
<br>
  <table>
      <thead>
          <tr>
              <th style="width: 20%;">Bank Code</th>
              <th style="width: 100%;">Bank Name</th>
              <th style="width: 30%;">Choose</th>
          </tr>
      </thead>
      <tbody>
          <tr *ngFor="let bank of BankList; let i = index">
              <td data-column="Bank Code">{{bank.bnkcode}}</td>
              <td data-column="Bank Name">{{bank.bnkname}}</td>
              <td data-column="Choose"><button type="button" class="theme-button btn"  name="submit" (click)="SelectBank(bank)">Select</button>
              </td>
          </tr>
      </tbody>
  </table>
</mat-dialog-content>


